import React from "react";
import Loader from "../../../common/loader";

const CustomerDashboard: React.FC = () => {
  const [isLoader, setIsLoader] = React.useState(true);

  setTimeout(() => {
   setIsLoader(false)
  }, 3000)
  return <div>{isLoader ? <Loader /> : <p>Dashboard page!</p>}</div>;
};

export default CustomerDashboard;
